import React from "react";
import { cn } from "@/lib/utils";
import { SrIcon } from "@/components/ui/SrIcon";

interface StepperNavProps {
  steps: string[];
  currentStep: number;
  onStepClick: (step: number) => void;
}

export function StepperNav({ steps, currentStep, onStepClick }: StepperNavProps) {
  return (
    <div className="flex items-center gap-1 mb-8 overflow-x-auto pb-2">
      {steps.map((s, i) => (
        <React.Fragment key={i}>
          <button
            type="button"
            onClick={() => i < currentStep && onStepClick(i)}
            // VIB-2546: steg som ikke er nådd kan ikke velges og hoppes over
            // med Tab; aktivt steg annonseres som «gjeldende steg».
            disabled={i > currentStep}
            aria-disabled={i > currentStep || undefined}
            aria-current={i === currentStep ? "step" : undefined}
            className={cn(
              "flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
              "disabled:cursor-default",
              i === currentStep
                ? "bg-primary text-primary-foreground"
                : i < currentStep
                  ? "bg-success/10 text-success"
                  : "bg-muted text-muted-foreground"
            )}
          >
            {i < currentStep ? (
              <SrIcon name="check" className="w-3 h-3"  />
            ) : (
              <span>{i + 1}</span>
            )}
            {s}
          </button>
          {i < steps.length - 1 && (
            <SrIcon name="chevron-right" className="w-4 h-4 text-muted-foreground shrink-0"  />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
